import ToggleMetrics from "views/components/ToggleMetrics";
import ChevronIcon from "assets/icons/ChevronIcon";
import { RightPaneMetrics } from "types";
import { motion } from "framer-motion";
import classNames from "classnames";

import styles from "./style.module.scss";

interface AccordianHeaderProps {
  title: string;
  icon?: JSX.Element;
  isLoading: boolean;
  isExpanded: boolean;
  selectedMetric: RightPaneMetrics | null;
  onToggle: () => void;
  onToggleMetrics: () => void;
}

const AccordianHeader = ({
  icon,
  title,
  isLoading,
  isExpanded,
  selectedMetric,
  onToggle,
  onToggleMetrics,
}: AccordianHeaderProps) => {
  const handleHeaderClick = () => {
    if (!isExpanded) {
      onToggle();
    }
  };
  const handleToggleClick = () => {
    if (isExpanded) {
      onToggle();
    }
  };

  return (
    <div
      className={classNames(styles.accordianHeader, {
        [styles.collapsed]: !isExpanded,
      })}
      onClick={handleHeaderClick}
    >
      <div className={styles.leftContainer}>
        {icon && <div className={styles.icon}>{icon}</div>}
        <span className={styles.title}>{title}</span>
      </div>
      <div className={styles.rightContainer}>
        {selectedMetric && (
          <ToggleMetrics
            selectedMetric={selectedMetric}
            onToggle={onToggleMetrics}
          />
        )}
        <motion.div
          className={styles.button}
          onClick={handleToggleClick}
          initial={{ scale: 1 }}
          whileHover={{ scale: 1.03 }}
        >
          <motion.span
            className={styles.chevron}
            animate={{ rotate: !isExpanded ? 180 : 0 }}
            transition={{ duration: 0.5 }}
          >
            <ChevronIcon direction="up" />
          </motion.span>
        </motion.div>
      </div>
      {isLoading && (
        <div className={styles.loaderBar}>
          <div className={styles.glow}></div>
        </div>
      )}
    </div>
  );
};
export default AccordianHeader;
